import { useEffect, useState } from 'react';

import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import DeleteRed from '../../../../images/delete-red.svg';
import './actionModal.scss';

interface IActionModalProps extends IChildren {
  closeAction: any;
  validAction: any;
  validText: any;
  modalType: any;
  monoButton?: boolean;
  hasIcon?: boolean;
}
const ActionModal = ({
  children,
  closeAction,
  validAction,
  validText = 'VALIDER',
  modalType = 'suppression',
  monoButton,
  hasIcon,
}: IActionModalProps) => {
  const [title, setTitle] = useState('');
  const [image, setImage] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    switch (modalType) {
      case 'suppression':
        setTitle('SUPPRESSION');
        setImage(DeleteRed);
        break;
      case 'timeout':
        setTitle('Temps Dépassé');
        break;
      default:
        break;
    }
  }, []);

  return (
    <div className="overlay">
      <div className="window-modal">
        <h3>{title}</h3>

        <div className="window-modal-container">
          {image && (
            <div className="window-modal-container-icon">
              <img src={image} />
            </div>
          )}
          <div className="window-modal-container-content">{children}</div>
        </div>

        <footer className="window-modal-footer">
          {!monoButton && (
            <Button
              btnType="button"
              btnContent="ANNULER"
              handleClick={closeAction}
              textColor="violet"
              bgColor="white"
              borderColor="grey"
            />
          )}
          <Button
            btnType="button"
            btnContent={validText}
            primary
            handleClick={() => dispatch(validAction)}
          />
        </footer>
      </div>
    </div>
  );
};

export default ActionModal;
